import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import takerConnectStore from '../../store/takerConnectStore';
import { ConnectionService } from '../../types/takerConnect';
import Msegat from '../Msegat/Msegat';
import Unifonic from '../Unifonic/Unifonic';

const ConnectionServices: FC = observer((): JSX.Element => {
  const sortedServices = useMemo(
    () => [...takerConnectStore.services.values()].sort((a, b) => Number(a.priority) - Number(b.priority)),
    [takerConnectStore.services]
  );

  return (
    <div className="d-flex flex-column gap-35">
      {sortedServices.map((service) => {
        switch (service.type) {
          case ConnectionService.Unifonic:
            return <Unifonic />;
          case ConnectionService.Msegat:
            return <Msegat />;
        }
      })}
    </div>
  );
});

export default ConnectionServices;
